import {LovValueSummary} from '../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {PartnerSummaryModel} from '../../../partner/common/api/model/partnerSummary.model';
import {BaseAuditableDto} from '../../../../shared/model/core/baseAuditableDto.model';
import {Moment} from 'moment';
import {PaymentRequestSummaryModel} from '../../modules/payment_request/api/entity/paymentRequestSummary.model';
import {SALE_STATUS} from './sale.model';
import {UserSummary} from '../../../account/modules/user/api/entity/userSummary.model';
import {SaleInvoiceSummaryModel} from '../../modules/invoice/api/entity/saleInvoiceSummary.model';
import {PurchaseOrderSummaryModel} from '../../modules/purchase_order/api/entity/purchaseOrderSummary.model';
import {OfficeSummaryModel} from "../../../office/api/model/officeSummary.model";

export class SaleSummaryModel extends BaseAuditableDto {
    id: number;
    status: LovValueSummary;
    direction: LovValueSummary;
    partner: PartnerSummaryModel;
    invoices: SaleInvoiceSummaryModel[] = [];
    purchaseOrders: PurchaseOrderSummaryModel[] = [];
    discountRate: number;
    discountDescription: string;
    discountAmountVatExcluded: number;
    totalPriceVatIncluded: number;
    totalPriceVatExcluded: number;
    totalVat: number;
    date: Moment;
    label: string;
    paymentRequests: PaymentRequestSummaryModel[] = [];
    responsibleUser: UserSummary;
    balance: number;
    office: OfficeSummaryModel;

    isPaid(): boolean {
        if (this.status?.value === SALE_STATUS.SALE_STATUS_COMPLETED) {
            return true;
        }
        if (this.paymentRequests
            .filter(value => !value.isPaid())
            .length === 0 && this.paymentRequests.length > 0) {
            return true;
        }
        return false;
    }

    isWaitingForConfirmation(): boolean {
        return this.status?.value === SALE_STATUS.SALE_STATUS_WAITING_CONFIRMATION;
    }

    isAcceptedOrAbove(): boolean {
        return this.status?.value === SALE_STATUS.SALE_STATUS_ACCEPTED ||
            this.status?.value === SALE_STATUS.SALE_STATUS_COMPLETED ||
            this.status?.value === SALE_STATUS.SALE_STATUS_DELIVERY_IN_PROGRESS;
    }

    resolveColor(): string {
        switch (this.status.value) {
            case SALE_STATUS.SALE_STATUS_WAITING_CONFIRMATION:
                return 'danger';
            case SALE_STATUS.SALE_STATUS_REFUSED:
                return 'danger';
            case SALE_STATUS.SALE_STATUS_COMPLETED:
                return 'success';
        }
        return undefined;
    }
}
